// Components==============
import React from "react";
import Button from "components/UI/Button";
import { useSelector } from "react-redux";
import NewsCard from "screens/Home/components/NewsCard";
import "./index.module.scss";
// =========================

export default function News({
    buttonBackground = "#1E265C",
    buttonColor = "#FFFFFF",
}) {
    const news = useSelector((state) =>
        state?.news?.entities?.allIds
            ?.map((id) => state?.news?.entities?.byId[id])
            ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    );

    // format date
    const formattedDate = (date) => {
        const d = new Date(date).toLocaleString("nl-NL", {
            timeZone: "Europe/Amsterdam",
        });
        const day = String(d.toLocaleString("nl-NL", { day: "short" })).split(
            ":00"
        )[0];
        return `${day}`;
    };

    return (
        <div styleName="container">
            <h2
                style={{
                    padding: "0.5rem",
                    marginBottom: "0.8rem",
                    marginLeft: "0.3rem",
                }}
            >
                Nieuws
            </h2>
            <div styleName="wrapper">
                {news
                    ?.filter((n, i) => i <= 2)
                    .map((item, i) => (
                        <NewsCard
                            key={i}
                            image={item.image}
                            created_at={formattedDate(item.created_at)}
                            title={item.title}
                            content={item.content}
                            id={item.id}
                        />
                    ))}
            </div>
            <div styleName="btn">
                <Button
                    onClick={() => {
                        window.location.href = "/nieuws";
                    }}
                    background={buttonBackground}
                    color={buttonColor}
                    style={{ width: "max-content" }}
                >
                    Nieuwsoverzicht
                </Button>
            </div>
        </div>
    );
}
